module.exports = __webpack_public_path__ + "static/img/automation.b2cc72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automation.png
// module id = orhT
// module chunks = 1